module.exports = __webpack_public_path__ + "img/freediving-4.4648849f.jpeg";